import '@angular/localize/init';
import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppShellComponent } from './app/layout/app-shell.component';
import { APP_ROUTES } from './app/app.routes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { ENV } from './app/public/faq/faq.service';



bootstrapApplication(AppShellComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    // ENV provider used by FaqService to switch between mock/API
    { provide: ENV, useValue: { public: { useMockFaq: true } } }
  ]
}).catch(err => console.error(err));
